export const SOME_RANDOM_CONTENT = "SOME_RANDOM_CONTENT";
export const VEHICLE = "VEHICLE";
export const DRIVER_SUGGESTIONS = "DRIVER SUGGESTIONS";
export const VEHICLE_SUGGESTIONS = "VEHICLE SUGGESTIONS";
export const LEASE_INFORMATION = "LEASE INFORMATION";

export const CARD_METRIC_LEASE = "cardMetricLease";
export const CARD_METRIC_UTILISATION = "cardMetricUtilisation";
export const CARD_METRIC_VEHICLE = "cardMetricVehicle";
export const CARD_METRIC_DRIVER = "cardMetricDriver";
export const REPORT_HEADING = "Reports";

export const DRIVER_ALERT_TEXT = "This driver may potentially be suspended";
export const VEHICLE_ALERT_TEXT = "This is a key utilised vehicle";
export const BOOKMARKED = "bookmarked";
export const BOOKMARK_HINT_TEXT =
	"Click here to see all your bookmarks or find them in your profile panel";

export const REPORT_FLAG = "REPORTS";
export const CARD_FLAG = "CARD"; 

export const VEHICLE_INFORMATION = "Vehicle Information";





// WEBPACK FOOTER //
// ./src/features/dashboard/content.js